import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowRight } from '@fortawesome/free-solid-svg-icons'

import { toExternalImage } from '../lib/dropify'

const GLOVE_BRANDS = [
  {
    name: 'Gekko Grip',
    href: '/sarung-tangan-gekko',
    hub: '/merek/gekko',
    image: '/lp/sarung-tangan-gekko-spread.jpeg',
    alt: 'Pilihan sarung tangan Gekko Grip berlapis nitrile',
    detail: 'Sarung tangan kerja rajut dengan pilihan lapisan nitrile dan PU.',
  },
  {
    name: 'Matahari',
    href: '/sarung-tangan-matahari',
    hub: '/merek/matahari',
    image: toExternalImage('https://s3.us-east-2.amazonaws.com/8grams-vorme/704f03f1-2dce-4e83-827e-349562728803/2026/08/18/d8c5e60934954b73aec12b461569e791.jpeg', { width: 480, format: 'webp', quality: 76 }),
    alt: 'Sarung tangan Matahari putih dengan bintik hitam',
    detail: 'Rajut berbintik PVC untuk menangani karton dan barang kering.',
  },
  {
    name: 'Diamond',
    href: '/sarung-tangan-diamond',
    hub: '/merek/diamond',
    image: toExternalImage('https://s3.us-east-2.amazonaws.com/8grams-vorme/704f03f1-2dce-4e83-827e-349562728803/2026/06/11/c9c7d0901ffa450fb195938189e99096.jpeg', { width: 480, format: 'webp', quality: 76 }),
    alt: 'Sarung tangan Diamond rajut abu-abu dengan bintik kuning',
    detail: 'Rajut abu-abu berbintik PVC untuk gudang dan pengemasan.',
  },
  {
    name: 'Bulldozer',
    href: '/sarung-tangan-bulldozer',
    hub: '/merek/bulldozer',
    image: toExternalImage('https://s3.us-east-2.amazonaws.com/8grams-vorme/704f03f1-2dce-4e83-827e-349562728803/2026/08/18/eca092f285324e848ac405f2dca35f17.jpeg', { width: 480, format: 'webp', quality: 76 }),
    alt: 'Sarung tangan Bulldozer rajut abu-abu dan kemasannya',
    detail: 'Rajut abu-abu tanpa bintik untuk menangani barang kering.',
  },
  {
    name: 'COMET',
    href: '/sarung-tangan-comet',
    hub: '/merek/comet',
    image: toExternalImage('https://s3.us-east-2.amazonaws.com/8grams-vorme/704f03f1-2dce-4e83-827e-349562728803/2026/07/23/a689b8c4a46848bcac1cfd8e60598cd8.png', { width: 480, format: 'webp', quality: 76 }),
    alt: 'Sarung tangan COMET CG 805 WT dengan lapisan PU di telapak',
    detail: 'Pilihan seri PU, nitrile, dan model kerja lain dengan spesifikasi per seri.',
  },
] as const

type GloveBrandPath = (typeof GLOVE_BRANDS)[number]['href']

export function GloveBrandAlternatives({ currentPath }: { currentPath: GloveBrandPath }) {
  const current = GLOVE_BRANDS.find((brand) => brand.href === currentPath)!
  const alternatives = GLOVE_BRANDS.filter((brand) => brand.href !== currentPath)

  return (
    <section aria-labelledby="merek-sarung-tangan-lain" className="border-y border-slate-200 bg-[#edf2e7] py-16 md:py-20">
      <div className="mx-auto max-w-7xl px-4">
        <div className="max-w-3xl">
          <p className="text-xs font-black uppercase tracking-[0.2em] text-lime-700">Pilihan merek lain</p>
          <h2 id="merek-sarung-tangan-lain" className="mt-3 text-3xl font-black tracking-tight md:text-4xl">Mencari sarung tangan kerja selain {current.name}?</h2>
          <p className="mt-4 text-base leading-relaxed text-slate-600">Dropify menyediakan pilihan merek di bawah ini. Lihat model serta kegunaannya sebelum meminta penawaran.</p>
        </div>
        <div className="mt-9 grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {alternatives.map((brand) => (
            <a key={brand.href} href={brand.href} className="group flex h-full flex-col overflow-hidden rounded-3xl border border-slate-200 bg-white transition-all hover:-translate-y-1 hover:border-lime-500 hover:shadow-xl focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-lime-700">
              <div className="overflow-hidden bg-[#f8f9f5] p-5">
                <img src={brand.image} alt={brand.alt} width="480" height="480" loading="lazy" decoding="async" className="aspect-square w-full object-contain transition-transform duration-500 group-hover:scale-105" />
              </div>
              <div className="flex flex-1 flex-col p-5">
                <h3 className="text-xl font-black tracking-tight text-slate-900">Sarung tangan {brand.name}</h3>
                <p className="mt-2 flex-1 text-sm leading-relaxed text-slate-600">{brand.detail}</p>
                <span className="mt-5 inline-flex items-center gap-2 text-sm font-black text-lime-800 group-hover:underline">
                  Lihat sarung tangan {brand.name}
                  <FontAwesomeIcon icon={faArrowRight} className="h-4 w-4" />
                </span>
              </div>
            </a>
          ))}
        </div>
        <a href={current.hub} className="mt-8 inline-flex items-center gap-2 text-sm font-bold text-slate-700 underline-offset-4 hover:underline">Lihat semua produk {current.name} <FontAwesomeIcon icon={faArrowRight} className="h-4 w-4" /></a>
      </div>
    </section>
  )
}
